// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rxVeO4wseKvXUghN{margin-top:16px}.rxVeO4wseKvXUghN .W4yxe7ovx1kXWVPa{display:grid;width:100%;height:100%;place-items:center;min-height:368px}.p1zYa0EpUvIZgx35{display:flex;margin-right:8px;gap:8px}.p1zYa0EpUvIZgx35 .e0wcxx6qZ48Zj45h{display:flex;align-items:center;gap:8px}.p1zYa0EpUvIZgx35 .e0wcxx6qZ48Zj45h .kle1XxEFYI0JywgS{height:24px;width:150px;margin:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardBody": `rxVeO4wseKvXUghN`,
	"emptyChart": `W4yxe7ovx1kXWVPa`,
	"dropdowns": `p1zYa0EpUvIZgx35`,
	"labeledInput": `e0wcxx6qZ48Zj45h`,
	"select": `kle1XxEFYI0JywgS`
};
export default ___CSS_LOADER_EXPORT___;
